import { render } from "./group-visits.vue?vue&type=template&id=dd526ca6&scoped=true"
import script from "./group-visits.vue?vue&type=script&lang=js"
export * from "./group-visits.vue?vue&type=script&lang=js"

import "./group-visits.vue?vue&type=style&index=0&id=dd526ca6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd526ca6"]])

export default __exports__